import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { supabase } from '../supabaseClient';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: '',
    smsConsent: false,
    emailConsent: false
  });
  const [status, setStatus] = useState('');
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate consent if phone is provided
    const newErrors = {};
    if (formData.phone && !formData.smsConsent) {
      newErrors.smsConsent = 'You must consent to receive SMS messages if providing a phone number';
    }
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    setStatus('sending');
    setErrors({});

    try {
      const { error } = await supabase
        .from('aramco_leads_contacts')
        .insert([{
          name: formData.name,
          email: formData.email,
          company: formData.company,
          phone: formData.phone,
          message: formData.message,
          sms_consent: formData.smsConsent,
          email_consent: formData.emailConsent,
          consent_timestamp: new Date().toISOString(),
          ip_address: 'web_form',
          created_at: new Date().toISOString()
        }]);

      if (error) throw error;

      setStatus('success');
      setFormData({ name: '', email: '', company: '', phone: '', message: '', smsConsent: false, emailConsent: false });
    } catch (error) {
      console.error('Error:', error);
      setStatus('error');
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Us - Aramco Leads Pro</title>
        <meta name="description" content="Contact Aramco Leads Pro for CRM platform inquiries, support, or to start your free trial." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>Contact Us</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>Get in touch with our team</p>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem' }}>
          <div>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '2rem' }}>Send Us a Message</h2>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Name *</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #d1d5db' }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Email *</label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #d1d5db' }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Company</label>
                <input
                  type="text"
                  value={formData.company}
                  onChange={(e) => setFormData({...formData, company: e.target.value})}
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #d1d5db' }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Phone</label>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #d1d5db' }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Message *</label>
                <textarea
                  required
                  rows="5"
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #d1d5db' }}
                />
              </div>

              {/* SMS Consent - REQUIRED FOR A2P COMPLIANCE - LENDING SPECIFIC */}
              <div style={{ background: '#fef3c7', padding: '1.5rem', borderRadius: '8px', border: '2px solid #f59e0b' }}>
                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={formData.smsConsent}
                      onChange={(e) => setFormData({...formData, smsConsent: e.target.checked})}
                      style={{ marginTop: '0.25rem', width: '18px', height: '18px', cursor: 'pointer' }}
                    />
                    <span style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#78350f' }}>
                      <strong>SMS Consent for Lending Services:</strong> I consent to receive SMS messages from Aramco Leads Pro regarding 
                      <strong> loan offers, lending opportunities, and financial services</strong>. This includes promotional messages about 
                      loan products and application updates. Message frequency varies (up to 10 messages per month). 
                      <strong>Message & data rates may apply</strong>. Reply <strong>STOP</strong> to opt-out at any time. 
                      Reply <strong>HELP</strong> for assistance. <strong>Consent is not a condition of obtaining any loan or financial service.</strong>
                    </span>
                  </label>
                  {errors.smsConsent && <p style={{ color: '#ef4444', fontSize: '0.875rem', marginTop: '0.5rem' }}>{errors.smsConsent}</p>}
                </div>

                <div>
                  <label style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={formData.emailConsent}
                      onChange={(e) => setFormData({...formData, emailConsent: e.target.checked})}
                      style={{ marginTop: '0.25rem', width: '18px', height: '18px', cursor: 'pointer' }}
                    />
                    <span style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#1e3a8a' }}>
                      <strong>Email Consent:</strong> I consent to receive email communications from Aramco Leads Pro. 
                      I can unsubscribe at any time by clicking the unsubscribe link in emails.
                    </span>
                  </label>
                </div>

                <p style={{ fontSize: '0.85rem', color: '#78350f', marginTop: '1rem', fontStyle: 'italic' }}>
                  By submitting this form, you acknowledge that you have read and agree to our{' '}
                  <a href="/privacy" style={{ color: '#92400e', textDecoration: 'underline' }}>Privacy Policy</a>,{' '}
                  <a href="/terms" style={{ color: '#92400e', textDecoration: 'underline' }}>Terms of Service</a>, and{' '}
                  <a href="/lending-compliance" style={{ color: '#92400e', textDecoration: 'underline' }}>Lending Compliance</a> policies.
                </p>
              </div>

              <button
                type="submit"
                disabled={status === 'sending'}
                style={{
                  padding: '1rem',
                  background: '#1e40af',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: '600',
                  cursor: status === 'sending' ? 'not-allowed' : 'pointer',
                  opacity: status === 'sending' ? 0.7 : 1
                }}
              >
                {status === 'sending' ? 'Sending...' : 'Send Message'}
              </button>
              {status === 'success' && <p style={{ color: '#10b981', fontWeight: '600' }}>✓ Message sent successfully! We'll contact you soon.</p>}
              {status === 'error' && <p style={{ color: '#ef4444' }}>✗ Error sending message. Please try again.</p>}
            </form>
          </div>

          <div>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '2rem' }}>Contact Information</h2>
            <div style={{ background: '#f9fafb', padding: '2rem', borderRadius: '12px', marginBottom: '2rem' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Aramco 1 USA Corporation</h3>
              <p style={{ marginBottom: '0.5rem' }}><strong>DBA:</strong> Aramco Leads Pro</p>
              <p style={{ marginBottom: '1rem' }}>11 Linden Ave<br />Kearny, NJ 07032<br />United States</p>
              <p style={{ marginBottom: '0.5rem' }}><strong>EIN:</strong> 33-1773365</p>
              <p style={{ marginTop: '1rem' }}><strong>Email:</strong> info@aramcoleadspro.com</p>
              <p><strong>Support:</strong> support@aramcoleadspro.com</p>
            </div>

            <div style={{ background: '#dbeafe', padding: '2rem', borderRadius: '12px', border: '2px solid #3b82f6' }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1e40af', marginBottom: '1rem' }}>Business Hours</h3>
              <p style={{ color: '#1e3a8a' }}>Monday - Friday: 9:00 AM - 6:00 PM EST</p>
              <p style={{ color: '#1e3a8a' }}>Saturday - Sunday: Closed</p>
              <p style={{ color: '#1e3a8a', marginTop: '1rem', fontSize: '0.9rem' }}>
                24/7 support available for enterprise customers
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
